'use client';

import { Resource, ResourceBody } from '../resource';
import type { ImageViewerProps } from './ImageViewer.types';
import { Footer } from './layout/Footer';
import { Header } from './layout/Header';
import { ImageView } from './layout/ImageView';

function ImageViewer({
  style,
  className,
  id,
  heading,
  title,
  src,
  auditLog,
  onDownload,
  onFeedback,
  onEdit,
  onClose,
  testId = 'ui-image-viewer',
}: ImageViewerProps) {
  return (
    <Resource style={style} className={className} testId={testId}>
      <Header
        onDownload={
          onDownload
            ? () => {
                onDownload(id);
              }
            : undefined
        }
        onFeedback={
          onFeedback
            ? () => {
                onFeedback(id);
              }
            : undefined
        }
        onEdit={
          onEdit
            ? () => {
                onEdit(id);
              }
            : undefined
        }
        onClose={onClose}
      />
      <ResourceBody>
        <ImageView heading={heading} title={title} src={src} alt={title} />
      </ResourceBody>
      <Footer auditLog={auditLog} />
    </Resource>
  );
}

export { ImageViewer };
